export default __webpack_public_path__ + "static/media/eyecare.7bd219a8.png";